export default __webpack_public_path__ + "static/media/tow.1618bbdb.png";